import Container from "@mui/material/Container";
import { Box, Button, Grid, Typography } from "@mui/material";

import logo from "../assets/logo.png";
import AdbIcon from "@mui/icons-material/Adb";
import ComputerIcon from "@mui/icons-material/Computer";
import AppleIcon from "@mui/icons-material/Apple";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ShopIcon from "@mui/icons-material/Shop";
import { useNavigate, useLocation } from "react-router";
import { useNetwork } from "../providers/NetworkProvider";
import { useAuth } from "../providers/AuthenticationProvider";
import { useSnackbar } from "../providers/SnackbarProvider";
import Roadmap from "../components/Roadmap";
import { useTranslation } from "react-i18next";
import { useTranslationProvider } from "../providers/TranslationProvider";

export const Home = () => {
	function redirect(url: string) {
		window.location.href = url;
	}
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { language } = useTranslationProvider();

	return (
		<>
			<Box
				sx={{
					background: "#232839",
					padding: window.innerWidth > 600 ? "20vh 16vh" : "16vh 1vh",
				}}
			>
				<Container>
					<Typography
						variant="h2"
						align="left"
						sx={{
							fontFamily: "Work Sans !important",
							fontWeight: "600",
							fontSize: window.innerWidth < 600 ? "32px" : "52px",
							marginTop: window.innerWidth > 600 ? "8vh" : "0vh",
						}}
					>
						{language == "it" && (
							<>
								Unisciti al mondo di Xsee, la prima{" "}
								<span style={{ color: "#2AD4D4" }}>
									{" "}
									social trading{" "}
								</span>{" "}
								app sui CFD
							</>
						)}
						{language == null ||
							(language == "en" && (
								<>
									Join the world of Xsee, the first{" "}
									<span style={{ color: "#2AD4D4" }}>
										social trading
									</span>{" "}
									app on CFDs
								</>
							))}
					</Typography>
					<Typography
						mt={2}
						variant="h6"
						align="left"
						sx={{
							fontFamily: "Work Sans !important",
							fontWeight: "300",
							fontSize: window.innerWidth < 600 ? "16px" : "18px",
						}}
					>
						{t("landing.hero.body")}
					</Typography>
					<Roadmap></Roadmap>
					<Box
						sx={{
							textAlign: "center",
							position: "relative",
							top: "32px",
						}}
					>
						<KeyboardArrowDownIcon
							sx={{
								fontSize: "54px",
							}}
						></KeyboardArrowDownIcon>
					</Box>
				</Container>
			</Box>
			<Box
				sx={{
					padding: window.innerWidth > 600 ? "8vh 0" : "2vh 1vh",
				}}
			>
				<Container>
					<Grid container spacing={0}>
						<Grid
							md={4}
							xs={12}
							sx={{
								padding: "20px",
							}}
						>
							<Box className="card bg-green">
								<Box
									sx={{
										background: "#131721",
										width: "72px",
										height: "72px",
										textAlign: "center",
										borderRadius: "100px",
									}}
								>
									<ComputerIcon
										sx={{
											fontSize: "32px",
											marginTop: "20px",
											color: "#fff",
										}}
									></ComputerIcon>
								</Box>
								<div className="titleCard">
									<span className="badge">Desktop / VPS</span>
									Metatrader4
								</div>
								<div className="textCard">
									{t("landing.ifYouAreATrader")}{" "}
									<b>{t("landing.bestStrategies")}</b>
								</div>
								<Button
									variant="contained"
									color="primary"
									startIcon={<CandlestickChartIcon />}
									sx={{
										textTransform: "none",
										margin: "16px 0 8px 0",
										fontWeight: "600",
										borderRadius: "100px",
									}}
									onClick={() => {
										redirect("/signup");
									}}
								>
									{t("general.becomeATrader")}
								</Button>
							</Box>
						</Grid>

						<Grid
							md={4}
							xs={12}
							sx={{
								padding: "20px",
							}}
						>
							<Box className="card">
								<Box
									sx={{
										background: "#131721",
										width: "72px",
										height: "72px",
										textAlign: "center",
										borderRadius: "100px",
									}}
								>
									<AppleIcon
										sx={{
											fontSize: "32px",
											marginTop: "20px",
											color: "#fff",
										}}
									></AppleIcon>
								</Box>

								<div className="titleCard">
									<span className="badge">
										{t("landing.mobilePhone")}
									</span>
									iOS
								</div>
								<div className="textCard">
									{language == "it" && (
										<>
											Installa l'app di xsee sul tuo
											dispositivo <b>Apple</b>
										</>
									)}
									{language == null ||
										(language == "en" && (
											<>
												Install the xsee app on your{" "}
												<b>Apple</b> device
											</>
										))}
								</div>

								<Button
									variant="contained"
									color="secondary"
									startIcon={<AppleIcon />}
									sx={{
										textTransform: "none",
										margin: "16px 0 8px 0",
										fontWeight: "600",
										borderRadius: "100px",
									}}
									onClick={() => {
										redirect(
											"https://apps.apple.com/it/app/xsee/id6467227843"
										);
									}}
								>
									Download iOS
								</Button>
							</Box>
						</Grid>

						<Grid
							md={4}
							xs={12}
							sx={{
								padding: "20px",
							}}
						>
							<Box className="card">
								<Box
									sx={{
										background: "#131721",
										width: "72px",
										height: "72px",
										textAlign: "center",
										borderRadius: "100px",
									}}
								>
									<AdbIcon
										sx={{
											fontSize: "32px",
											marginTop: "20px",
											color: "#fff",
										}}
									></AdbIcon>
								</Box>
								<div className="titleCard">
									<span className="badge">
										{t("landing.mobilePhone")}
									</span>
									Android
								</div>
								<div className="textCard">
									{language == "it" && (
										<>
											Installa l'app di xsee sul tuo
											dispositivo <b>Android</b>
										</>
									)}
									{language == null ||
										(language == "en" && (
											<>
												Install the xsee app on your{" "}
												<b>Android</b> device
											</>
										))}
								</div>

								<Button
									variant="contained"
									color="secondary"
									startIcon={<ShopIcon />}
									sx={{
										textTransform: "none",
										margin: "16px 0 8px 0",
										fontWeight: "600",
										borderRadius: "100px",
									}}
									onClick={() => {
										redirect(
											"https://play.google.com/store/apps/details?id=com.sinapsa.Xsee&pli=1"
										);
									}}
								>
									Download Android
								</Button>
							</Box>
						</Grid>
					</Grid>
				</Container>
			</Box>
			<Box
				sx={{
					background: "#232839",
					padding: window.innerWidth > 600 ? "16vh" : "16vh 1vh",
				}}
			>
				<Container>
					<Typography
						variant="h3"
						align="center"
						sx={{
							fontFamily: "Work Sans !important",
							fontWeight: "600",
							fontSize: window.innerWidth < 600 ? "32px" : "56px",
						}}
					>
						{t("general.becomeATraderNow")}
					</Typography>
					<Typography
						mt={2}
						variant="h6"
						align="center"
						sx={{
							fontFamily: "Work Sans !important",
							fontWeight: "300",
							fontSize: window.innerWidth < 600 ? "16px" : "18px",
						}}
					>
						{t("general.shareStrategies")}
					</Typography>
					<Button
						variant="contained"
						color="secondary"
						startIcon={<CandlestickChartIcon />}
						sx={{
							textTransform: "none",
							margin: "16px auto 8px auto",
							fontWeight: "600",
							borderRadius: "100px",
							display: "flex",
						}}
						onClick={() => {
							redirect("/signup");
						}}
					>
						{t("general.signupAsTrader")}
					</Button>
				</Container>
			</Box>
			<Box
				sx={{
					padding: window.innerWidth > 600 ? "8vh 0" : "2vh 1vh",
				}}
			>
				<Container>
					<Grid container spacing={2}>
						<Grid md={2} xs={0}></Grid>
						<Grid md={4} xs={12}>
							<a
								className="footer_url"
								style={{ color: "#fff" }}
								onClick={() => navigate("terms-condition")}
								target="_blank"
							>
								{t("footer.termsOfUse")}
							</a>
						</Grid>
						<Grid md={4} xs={12}>
							<a
								className="footer_url"
								style={{ color: "#fff" }}
								onClick={() => navigate("terms-condition")}
								target="_blank"
							>
								{t("footer.privacyPolicy")}
							</a>
						</Grid>
					</Grid>
				</Container>
			</Box>
		</>
	);
};
